import * as d3 from "d3";
import * as React from "react";
import { Component } from "react";
import * as VisUtils from "../lib/VisUtils";

const TOOLTIP_TO_TARGET_GAP = 8 + 3;

export interface TooltipProps {
  classModifier?: string;
  anchor?: string;
  position: any;
  text?: any;
  value: any;
}

export class Tooltip extends Component<TooltipProps> {
  ref: null | HTMLDivElement = null;
  refFn = (ref: null | HTMLDivElement): void => {
    this.ref = ref;
  };

  getAnchor() {
    return this.props.anchor || "north";
  }

  componentDidMount() {
    this.updatePosition();
    if (this.ref) {
      d3.select(this.ref).classed("is-added", true);
    }
  }

  componentDidUpdate() {
    this.updatePosition();
  }

  updatePosition() {
    const ref = this.ref;
    if (ref) {
      const position = d3.functor(this.props.position);
      const anchor = this.getAnchor();

      requestAnimationFrame(() => {
        VisUtils.anchorPosition(ref, position(), anchor, {
          ygap: TOOLTIP_TO_TARGET_GAP,
        });
      });
    }
  }

  render() {
    const { classModifier, text, value } = this.props;

    return (
      <div ref={this.refFn} className={"tooltip" + (classModifier ? " " + classModifier : "")}>
        <span className="tooltip__value">{value}</span>
        {text && <span className="tooltip__text">{text}</span>}
        <span className={"tooltip__triangle is--" + this.getAnchor()} />
      </div>
    );
  }
}

export default Tooltip;
